import VectorLayer from 'ol/layer/Vector';
import CanvasVectorLayerRenderer from 'ol/renderer/canvas/VectorLayer';

/**
 * Vector Layer, which uses a single layer style for all features.
 *
 * The ol.layer.Vector uses the standard OL renderer, which takes the feature individual styles in
 * the first place and uses the layer style only as a default if feature does not have it's own style.
 *
 * This layer ignores the individual feature styles and always uses the layer style for feature rendering.
 *
 * Can be used as an overlay layer for example for the interactions:
 * - add a unified selection styling for the selection interaction.
 * - show drag handles for all features for the TranslateByHandle interaction.
 *
 * @class
 */
export class OverlayVectorLayer extends VectorLayer {

  _getMap;

  constructor (options) {
    super(options);
    this._getMap = options.getMap;
  }

  createRenderer () {
    return new OverlayVectorLayerRenderer(this, this._getMap);
  }

}

class OverlayVectorLayerRenderer extends CanvasVectorLayerRenderer {

  _getMap;

  constructor (layer, getMap) {
    super(layer);
    this._getMap = getMap;
  }

  renderFeature (feature, squaredTolerance, styles, builderGroup, optTransform) {
    // always use the layer's style
    styles = this.getLayer().getStyleFunction()(feature, this._getMap().getView().getResolution());
    return super.renderFeature(feature, squaredTolerance, styles, builderGroup, optTransform);
  }

}
